
import React, { useState, useEffect } from "react";
import SubTitle from "../../components/Title/subTitle";
import CommonlyChart from "../../components/charts";
import './Block2.scss'

const Block2 = ({ title, selectData, data, option, chartHeight = 70, titleStyle = {} }) => {
  return (
    <div className="block2">
      <SubTitle style={{ marginBottom: 11, ...titleStyle }} title={title} />
      <div className="flex flexBetween alignItemEnd">
        <div className="flexColumn alignItemCenter">
          <div style={{ width: 120, height: 48 }}>
            {data && data[0] && data[0].map((item, index) => {
              return <div style={{ marginBottom: 8 }} key={index}>
                <div className="text1">{item.label}</div>
                <div className="font14 blod numberFont">{item.value}</div>
              </div>
            })}
          </div>
          <div className="flex alignItemCenter" style={{ width: 120 }}>
            {data && data[1] && data[1].map((item, index) => {
              return <div className="mr4" key={index}><div className="text2">{item.label}</div><div className="font15 blod numberFont">{item.value}</div></div>
            })}
          </div>
        </div>
        <div>
          <CommonlyChart
            option={option}
            height={chartHeight}
            width={70}
            pieEmphasis
          ></CommonlyChart>
        </div>
      </div>
    </div>
  )
}

export default Block2
